import axios, { AxiosResponse } from "axios";
import { baseUrl } from "../utils/Config";
import { logout } from "../utils/CommonFunctions";



const newBaseUrl = () => {
  if (window.location.protocol === "http:") {
    let newBaseUrl: string | undefined = baseUrl;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseUrl;
  }
};

export const getRequest = async (endPoint: string) => {
  try {
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Connection: "close",
      Authorization: "Bearer " + global.authToken,
    },
  });
  return response
}
  catch (error: any) {
    if(error.response.status == 403) {
      logout("network");
    }
   throw error
  }
};
export const postRequest = async (endPoint: string, data: {}) => {
  try {
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "POST",

    headers: {
      "Content-Type": "application/json",
      Connection: "close",
      Authorization: "Bearer " + global.authToken,
    },
    data: data,
    // timeout: requestTimeout,
  });

  return response;
}
catch (error: any) {
  if(error.response.status == 403) {
    logout("network");
  } 
  throw error
}
};

export const postRequestMulitiPart = async (endPoint: string, data: {}) => {
  try{
  const response = await axios({
    url: `${newBaseUrl()}${endPoint}`,
    method: "POST",

    headers: {
      "Content-Type": "multipart/form-data",
      Connection: "close",
      Authorization: "Bearer " + global.authToken,
    },
    data: data,
    // timeout: requestTimeout,
  });


  return response;
}catch (error: any) {
  if(error.response.status == 403) {
    logout("network");
  }
  throw error  
}
};
